import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'name',
    name: 'page.numerical-serie.col-name',
  },
  {
    accessor: 'format',
    name: 'page.numerical-serie.col-dn-format',
  },
  {
    accessor: 'formatVariableSymbol',
    name: 'page.numerical-serie.col-vs-format',
  },
  {
    accessor: 'documentType',
    name: 'page.numerical-serie.col-document-type',
  },
  {
    accessor: 'counterForEachMonth',
    name: 'page.numerical-serie.col-counter-each-month',
    cellRenderer: (e) => (
      <div>
        <input type={'checkbox'} checked={e.counterForEachMonth} readOnly className={`w-4 h-4`} />
      </div>
    ),
  },
];
